/* eslint-disable @reatom/unit-naming-rule */
import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'

import { Button } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency'
import { WalletAssetsPriceCell } from '@root/entities/wallet/ui/table/column/wallet-asset-column/wallet-assets-price-cell'
import { reatomToggleWalletAsset } from '@root/features/wallet/assets-management/atoms'
import { EyeClosedIcon } from '@root/shared/ui-kit'

import type { WalletAssetModel, WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
  asset: WalletAssetModel
}

export const WalletAssetsTablePriceCell: React.FC<Props> = ({
  asset,
  wallet,
}) => {
  const [priceUsd] = useAtom(asset.priceUsd)
  const toggleModel = useMemo(
    () =>
      reatomToggleWalletAsset({
        wallet: wallet,
        currency: asset.currency,
      }),
    [wallet, asset.currency],
  )
  const [requestState] = useAtom(toggleModel)
  const hideAsset = useAction(toggleModel.execute)

  const canHide = !CurrencyModel.isNative(asset.currency)

  return (
    <WalletAssetsPriceCell
      ticker={asset.currency.ticker}
      priceUsd={priceUsd}
      endSlot={
        canHide ? (
          <Button
            busy={requestState.loading}
            onClick={() => hideAsset()}
            radius="rounded"
            iconLeft={<EyeClosedIcon size={12} />}
            size="h24"
            variant="soft"
          />
        ) : undefined
      }
    />
  )
}
